import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'headerbar-detail',
  templateUrl: './page-header-detail.component.html',
  styleUrls: ['./page-header-detail.component.css']
})
export class PageHeaderDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
